import { render, staticRenderFns } from "./NeTreeForNoRealTaskCreate.vue?vue&type=template&id=6f2b253c&"
import script from "./NeTreeForNoRealTaskCreate.vue?vue&type=script&lang=js&"
export * from "./NeTreeForNoRealTaskCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports